/* src/app/views/template/components/templates/digital/digital-marketing-templates/digital-marketing-template-list/digital-marketing-template-list.component.scss */
/*# sourceMappingURL=digital-marketing-template-list.component.css.map */
